<template>
<div>
    <base-header v-once pageName="장바구니" :popup="true"></base-header>
    
    <section id="wrap">
        <div class="edu-cart">
            <div class="header">
                <em>{{ userInfo.custNm }}</em> 고객님 설계 상품
            </div>
            <div class="cart" v-for="(category, catIdx) in cateList" :key="catIdx">
                <template v-if="productList.filter((item) => item.catCd == category.cdVl1).length > 0">
                    <h6>{{ category.cdNm }}</h6>
                    <ul class="discount">
                        <li v-for="(item, index) in productList.filter((item) => item.catCd == category.cdVl1)" :key="index">
                            <strong>{{ item.prdtnm }}</strong>
                            <span>
                                <em :class="{ 'discount-price': item.dcYn === 'Y' }">{{ getProductAmount(item) | numFormat }}</em>원
                                <em class="list-price" v-if="item.dcYn === 'Y'"> {{ item.prdtAmt | numFormat }}</em>
                            </span>
                            <button type="button" class="count" @click="minusItem(item.salecdSqno)">-</button>
                            <i>{{ item.prchCnt }}</i>
                            <button type="button" class="count" @click="addItem(item.salecdSqno)">+</button>
                            <button type="button" class="del" @click="delItem(item.salecdSqno)">삭제</button>
                            
                            <p v-if="item.concMon">기간 : {{ item.concMon }}개월</p>
                            
                            <span class="checkbox" v-if="isDiscountProduct(item)">
                                <input type="checkbox" :id="`${item.catCd}_${index}`" v-model="item.dcYn" true-value="Y" false-value="N">
                                <label :for="`${item.catCd}_${index}`">10% 할인</label>
                            </span>
                        </li>
                    </ul>
                    <ul class="pro-total">
                        <li>
                            <span>상품합계</span>
                        </li>
                        <li>
                            <span class="discount-sum" v-if="isDiscountSelected(category.cdVl1)">
                                <em>{{ totAmtByCategory(category.cdVl1) | numFormat }}</em>원
                            </span>
                            <span class="list-sum">
                                <em>{{ totDcAmtByCategory(category.cdVl1) | numFormat }}</em>원
                            </span>
                        </li>
                    </ul>
                </template>
            </div>
            <div class="cart use" v-if="cateCntList.length > 0">
                <h6>기존이용상품</h6>
                <div>
                    <span v-for="(item,index) in cateCntList" :key="index">{{ item.catNm }}({{ item.concCnt }}종)</span>
                </div>
                <p>
                    <span>월 납입금액</span>
                    <strong>{{ monthAmt | numFormat }}원</strong>
                </p>
            </div>
            <div class="price">
                <dl class="gap">
                    <dt>신규 결제금액</dt>
                    <dd><em>{{ planAMT + homeclassAMT | numFormat }}</em>원</dd>
                    <dt>
                        <button type="button" @click="coupon" >M/F할인<em class="underline">선택</em>하기(할인:{{ cpEA }}건)</button>
                        <div class="dim" v-show='selectBoxView'>
                            <div class="botWrap coupon">
                                <h6>할인정보 <span>총 <em>{{ custPlanInfo.dcSqnoList.length }}</em>개</span></h6>
                                <div>
                                    <span>할인내용</span>
                                    <span>할인금액</span>
                                </div>
                                <ul>
                                    <li v-for="(item,index) in discountList" :key="index"
                                        :class="{'chk': item.selected}"
                                        @click="cpChoice(item)"
                                    >
                                        <span>{{ item.titl }}</span>
                                        <em>-{{ item.dcAmt | numFormat }}원</em>
                                    </li>
                                </ul>
                                <button type="button" class="close" @click="cpClose">닫기</button>
                            </div>
                            <button type="button" @click="cpSelected">선택</button>
                        </div>
                    </dt>
                    <dd>-{{ cpAmtToal | numFormat }} 원</dd>
                    <dt>전집 할인금액</dt>
                    <dd>-{{ discountedAMT | numFormat }} 원</dd>
                    <dt class="opt">마일리지 입력</dt>
                    <dd><input type="tel" v-model="strMlgAmt" placeholder="0"> M</dd>
                    <dt class="opt">선납금액</dt>
                    <dd><input type="tel" v-model="strPrpmAmt" placeholder="0"> 원</dd>
                    <dt class="opt">할부개월</dt>
                    <dd>
                        <base-selectbox selectName="할부개월"
                            :default="custPlanInfo.mntsCnt + '개월'" 
                            :only="false"
                            v-on:selectSearch="benefit"
                            :options="mntsCntList"
                        ></base-selectbox>
                    </dd>
                    <!-- <dt>최초 1회 신규 납입금액</dt>
                    <dd>월 <i>{{ firstMonth | numFormat }}</i> 원</dd> -->
                </dl>

                <dl class="total" >
                    <dt>결제 예상금액(월)</dt>
                    <dd><em>{{ payAMT | numFormat }}</em>원</dd>
                    <dt v-if="cateCntList.length > 0">신규상품 납입금액(월)</dt>
                    <dd v-if="cateCntList.length > 0">{{ firstMonth | numFormat }} 원</dd>
                    <dt v-if="cateCntList.length > 0">현재 납입금액(월)</dt>
                    <dd v-if="cateCntList.length > 0">{{ monthAmt | numFormat }} 원</dd>
                </dl>
                <p>* 결제금액은 실 계약과 상이할 수 있습니다.</p>
            </div>
        </div>
    </section>
    <div class="btnWrap">
        <button type="button" class="white" @click="close">취소</button>
        <button type="button" class="black" @click="save">저장</button>
        <button type="button" class="red" @click="contract">계약</button>
    </div>
</div>
</template>

<script>
import _ from 'lodash';
const HOMECLASS_INSTALLMENT_SUBJECTS = ["606", "607", "608", "609", "610"];

export default {
  name: "cart",
  components: {
  },
  data() {
      return{
        userName:this.$utils.ui.getUserName(),
        targetId:'',
        userInfo:[],
        cateList:[],
        productList:[],
        cpEA: 0,
        cpAmtToal: 0,
        discountList:[],
        custPlanInfo:{
            prpmAmt: 0,
            mlgAmt:0,
            mntsCnt: 12,
            dcSqnoList: [],
        },
        strPrpmAmt:'0',
        strMlgAmt:'0',
        cateCntList:[],
        selectBoxView: false,
        monthAmt: 0,
        mntsCntList:[
            {text:'12개월',value:'12'},
            {text:'24개월',value:'24'},
            {text:'28개월',value:'28'},
            {text:'36개월',value:'36'}
        ],
        mountYn : false,
        bfCoupons:[],
        dcRt: 0, // 전집 할인율(전집 && 프로모션 대상 상품 할인)
      }      
  },
  computed:{
      planAMT: function(){
        var sum = 0;
        for (var i = 0; i < this.productList.length; i++) {
            if("HC" != this.productList[i].catCd) {// 홈클 아닐때만
                sum += (this.getProductAmount(this.productList[i]) * this.productList[i].prchCnt)
            } else if ( // 홈클 이지만 일시불 상품은 할부 가능 하드코딩 ㅠ
                this.productList[i].catCd === "HC" &&
                HOMECLASS_INSTALLMENT_SUBJECTS.includes(this.productList[i].rpsubj)
            ) {
                sum += this.getProductAmount(this.productList[i]) * this.productList[i].prchCnt;
            }
        }
        return sum;
      },
      homeclassAMT: function(){
        var sum = 0;
        for (var i = 0; i < this.productList.length; i++) {
            if (
                this.productList[i].catCd === "HC" &&
                !HOMECLASS_INSTALLMENT_SUBJECTS.includes(this.productList[i].rpsubj)
            ) {              
                sum += (this.getProductAmount(this.productList[i]) * this.productList[i].prchCnt)
            }
        }
        return sum;
      },      
      payAMT: function() {
        var sum = this.monthAmt + this.firstMonth;
        return sum;
      },
      firstMonth: function(){       //할부금액(1원단위 절삭)
        var amt = (this.planAMT - this.cpAmtToal - this.custPlanInfo.prpmAmt - this.custPlanInfo.mlgAmt) / this.custPlanInfo.mntsCnt;
        amt = amt + this.homeclassAMT
        amt = amt/10
        var sum = Math.floor(amt);
        sum = sum*10;
        return sum;
      },
      // 전집 할인 금액
      discountedAMT() {
          let sum = _(this.productList)
              .filter(v => {
                  return v.dcYn === 'Y';  
              })
              .sumBy(v => {
                  return this.getDiscountAmountByRate(v.prdtAmt, this.dcRt) * v.prchCnt;
              });
          
          return sum || 0;
      }
  },
  watch: { // 팝업창에서 선택된 값 받는 부분.
    '$store.state.ui.child'(child) {
        if(child.name == 'eduplan_close_and_refresh'){
            this.$utils.nativeIf.outbound.close(true);
        }
    },
    'strPrpmAmt'(newVal){
        if(newVal.length > 1 && newVal.indexOf('0') == 0){
            newVal = newVal.substring(1)
        }
        var result = newVal.replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.strPrpmAmt = result, this.custPlanInfo.prpmAmt = newVal.replace(/\D/g, ""));
    },
    'strMlgAmt'(newVal){
        if(newVal.length > 1 && newVal.indexOf('0') == 0){
            newVal = newVal.substring(1)
        }
        var result = newVal.replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.strMlgAmt = result, this.custPlanInfo.mlgAmt = newVal.replace(/\D/g, ""));
    },
  },
  methods: {
    totDcAmtByCategory: function(catCd){
        var amt = 0;
        for(var i=0; i<this.productList.length; i++){
            if(this.productList[i].catCd == catCd){
                amt += (this.getProductAmount(this.productList[i]) * this.productList[i].prchCnt);
            }
        }
        return amt;
    },
    totAmtByCategory: function(catCd) {
        var amt = 0;
        for(var i=0; i<this.productList.length; i++){
            if(this.productList[i].catCd == catCd){
                amt += this.productList[i].prdtAmt * this.productList[i].prchCnt;
            }
        }
        return amt;
    },
    addItem: function(salecdSqno){
        for(var i=0 ; i<this.productList.length ; i++){
            if(this.productList[i].salecdSqno == salecdSqno){
                if(this.productList[i].prchCnt > 9){
                    alert("최대 10개까지 가능합니다.");
                }else{
                    this.productList[i].prchCnt +=1;
                }
                
                break;
            }
        }
    },
    minusItem: function(salecdSqno){
        for(var i=0 ; i<this.productList.length ; i++){
            if(this.productList[i].salecdSqno == salecdSqno){
                if( this.productList[i].prchCnt > 1 ){
                    this.productList[i].prchCnt -=1;
                }
                break;
            }
        }
    },
    delItem: function(salecdSqno){
        if(this.productList.length > 1){
            var delConfirm = confirm('해당 상품을 삭제하시겠습니까?');
            if (delConfirm) {
                for(var i=0 ; i<this.productList.length ; i++){
                    if(this.productList[i].salecdSqno == salecdSqno){
                        this.productList.splice(i, 1);
                    }
                }
            }
        }else{
            if(confirm('장바구니를 비우고 상품 선택 페이지로 이동하시겠습니까?')){
                this.productList.splice(0, 1);
                this.close();
            }
        }
    },
    coupon: function(){ // 할인정보 선택
        this.selectBoxView = !this.selectBoxView;
        if(this.selectBoxView){
            //열림
            this.bfCoupons = this.custPlanInfo.dcSqnoList;
        }
        this.cpEA = this.custPlanInfo.dcSqnoList.length;
    },
    cpChoice: function(item){ // 할인정보 선택
        this.$set(item, 'selected', !item.selected);
        this.custPlanInfo.dcSqnoList = []
        for (var i = 0; i < this.discountList.length; i++) {
            if(this.discountList[i].selected == true){
                this.custPlanInfo.dcSqnoList.push(this.discountList[i].dcSqno)
            }
        }
    },
    cpSelected: function(){ // 할인정보 적용
        if(this.selectBoxView)
            this.coupon();
        var idx = 0;
        for (var i = 0; i < this.discountList.length; i++) {
            if(this.discountList[i].selected == true){
                idx += this.discountList[i].dcAmt
            }
        }
        this.cpAmtToal = idx;
    },
    cpClose:function(){
        this.custPlanInfo.dcSqnoList = this.bfCoupons;

        for (var i = 0; i < this.discountList.length; i++) {
            this.discountList[i].selected = false
            if(this.custPlanInfo.dcSqnoList.indexOf(this.discountList[i].dcSqno) > -1){
                this.discountList[i].selected = true
            }
        }
        this.coupon();
    },
    benefit: function(date){
        this.custPlanInfo.mntsCnt = date
    },
    close:function(){   //취소
        this.$utils.nativeIf.outbound.close();
    },
    save:function(){   //저장
        if(!this.mountYn){
            return false;
        }
        let newPrdtList = _.map(this.productList, v => {
            return {
                salecdSqno: v.salecdSqno,
                prchCnt: v.prchCnt,
                dcYn: v.dcYn,
                dcRt: (v.dcYn === 'Y' ? this.dcRt : 0)
            };
        });
        
        if(!this.userInfo || !this.userInfo.custDiv){
            if(confirm("선택된 고객이 없습니다. 나만의 플랜으로 등록 하시겠습니까?")){
                var data = {
                    planReg:{
                        list:newPrdtList,
                        from:"cart"
                    }
                }
                var parent = this.$store.getters.parent;
                Object.assign(parent.data, data)
                
                this.$store.commit("SET_UI_PARENT", parent);    // 나만의 플랜 저장 화면으로 보내는 정보
                this.$utils.nativeIf.outbound.newPage('/eduplanmap/planReg');
            }
            return false;
        }

        if(this.firstMonth < 0){
            alert("구매 금액이 0보다 작습니다.");
            return false;
        }

        if(confirm("저장하시겠습니까?")){
            if(!this.custPlanInfo.prpmAmt){
                this.custPlanInfo.prpmAmt = 0
            }
            var saveParam = this.userInfo;
            saveParam.targetId = this.targetId;
            saveParam.userName = this.userName;
            saveParam.strSearchPrdt = JSON.stringify(newPrdtList);
            saveParam.strCustPlanInfo = JSON.stringify(this.custPlanInfo);
            var that = this
            this.$api.eduplan.myPlanSave(saveParam).then(function(data){
                // console.log(data)
                if(data > 0){
                    alert('저장되었습니다.');
                    
                    var child = {
                        name: "after-save-plan",
                        data: {}
                    };
                    that.$utils.nativeIf.outbound.sendChildData(child); //부모창 리스트 초기화
                }else{
                    alert("저장에 실패하였습니다.");
                }
            })
            .catch(function(error) {
                alert(error.rtMsg);
                if(error.rt && error.rt == 'cust_plan_duplicate'){
                    var child = {
                        name: "after-save-plan",
                        data: {}
                    };
                    that.$utils.nativeIf.outbound.sendChildData(child); //부모창 리스트 초기화
                }
            });
        }
    },
    contract:function(){    //계약
        if(!this.mountYn){
            return false;
        }
        var newPrdtList = []
        for(var n=0 ; n<this.productList.length ; n++){
            newPrdtList.push({salecdSqno: this.productList[n].salecdSqno,
                                prchCnt:this.productList[n].prchCnt})
        }

        if(!this.userInfo || !this.userInfo.custDiv){
            if(confirm("고객이 등록되지 않아, 계약 페이지로 연결하지 않습니다.\n나만의 플랜으로 등록 하시겠습니까?")){
                var data = {
                    planReg:{
                        list:newPrdtList,
                        from:"cart"
                    }
                }
                var parent = this.$store.getters.parent;
                Object.assign(parent.data, data)

                this.$store.commit("SET_UI_PARENT", parent);    // 나만의 플랜 저장 화면으로 보내는 정보
                this.$utils.nativeIf.outbound.newPage('/eduplanmap/planReg');
            }
            return false;
        }
        if(this.firstMonth < 0){
            alert("구매 금액이 0보다 작습니다.");
            return false;
        }
        
        if(!this.custPlanInfo.prpmAmt){
            this.custPlanInfo.prpmAmt = 0
        }
        
        var saveParam = this.userInfo;
        saveParam.targetId = this.targetId;
        saveParam.userName = this.userName;
        saveParam.strSearchPrdt = JSON.stringify(newPrdtList);
        saveParam.strCustPlanInfo = JSON.stringify(this.custPlanInfo);

        var that = this
        this.$api.eduplan.myPlanSave(saveParam).then(function(data){
            // console.log(data)
            if(data > 0){
                // open outlink kss 계약
                that.$api.dashboard
                .getSsoToken()
                .then(function (data) {
                    if(data && data.token && data.userIdEnc){
                        var ssoUrl = 'http://ksos.kyowon.co.kr?';
                        ssoUrl += 'userId='+data.userIdEnc+'&token='+data.token;
                        ssoUrl += '&path='+'/ordr/pick';

                        that.$utils.nativeIf.outbound.outlink(ssoUrl)
                        
                        var child = {
                            name: "after-save-plan",
                            data: {}
                        };
                        that.$utils.nativeIf.outbound.sendChildData(child); //부모창 리스트 초기화
                    }else{
                        that.$utils.nativeIf.outbound.outlink("https://ksos.kyowon.co.kr");
                    }
                })
                .catch(function (error) {
                    alert(error.rtMsg);
                });
            }else{
                alert("저장에 실패하였습니다.");
            }
        })
        .catch(function(error) {
            alert(error.rtMsg);
            if(error.rt && error.rt == 'cust_plan_duplicate'){
                var child = {
                    name: "after-save-plan",
                    data: {}
                };
                that.$utils.nativeIf.outbound.sendChildData(child); //부모창 리스트 초기화
            }
        });
    },
    // 전집 할인 대상 여부 반환
    isDiscountProduct(product) {
        return product.prdtDiv === 'C' && product.prmtAplyYn === 'Y';
    },
    // 전집 할인 적용인 경우 할인가, 그 외에는 정상가 반환
    getProductAmount(product) {
        return product.dcYn === 'Y' ? product.dcAmt : product.prdtAmt;
    },
    // 전집 할인율 적용 금액 반환
    getDiscountAmountByRate(productAmount, discountRate) {
        return productAmount * (discountRate / 100);
    },
    // 전집 할인 상품 선택 여부
    isDiscountSelected(catCd) {
        let length = _.filter(this.productList, v => {
            return v.catCd === catCd && v.dcYn === 'Y';
        }).length;
        return length > 0;
    }
  },
  filters:{
    numFormat:function(num){
        if(!num || num==0) return 0;

        var n = num+'';
        var reg = /(^[+-]?\d+)(\d{3})/;

        while (reg.test(n))
            n = n.replace(reg,'$1'+','+'$2');
        
        return n;
    },
  },
  created: function() { 
    var parent = this.$store.getters.parent;
    if(parent.data.planCart) {
        this.productList = parent.data.planCart.list;
        this.userInfo = parent.data.planCart.userInfo;
        this.targetId = parent.data.planCart.targetId;
    }
    var that = this;
    var param = this.userInfo;
    param.strSearchPrdt = JSON.stringify(this.productList);
    param.targetId = this.targetId

    this.$api.eduplan.bascket(param).then(function (data) {
        that.mountYn = true;
        console.log(data.cateList)

        // 전집 할인 금액 셋팅
        that.productList = _.map(data.productList, v => {
            if (that.isDiscountProduct(v)) {
                v.dcAmt = v.prdtAmt - that.getDiscountAmountByRate(v.prdtAmt, data.dcRt);
            } else {
                // 할인을 선택했더라도 프로모션 해제 시 기존 값 초기화
                v.dcYn = 'N'; 
                v.dcRt = 0;
                v.dcAmt = v.prdtAmt;
            }
            return v;
        });
        if (data.cateList) {
            that.cateList = data.cateList
        }
        if (data.custPlanInfo) {
            that.custPlanInfo = JSON.parse(JSON.stringify(data.custPlanInfo));
            if (that.custPlanInfo.mntsCnt < 12) {
                that.custPlanInfo.mntsCnt = 12
            }
            if (data.custPlanInfo.prpmAmt) {
                that.strPrpmAmt = data.custPlanInfo.prpmAmt.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            if (data.custPlanInfo.mlgAmt) {
                that.strMlgAmt = data.custPlanInfo.mlgAmt.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            if (data.custPlanInfo.dcSqnoList) {
                that.custPlanInfo.dcSqnoList = data.custPlanInfo.dcSqnoList
            } else {
                that.custPlanInfo.dcSqnoList = []
            }
        }

        if (data.discountList) {  //할인정보 있을때
            that.discountList = data.discountList
            if (data.custPlanInfo && data.custPlanInfo.dcSqnoList) {  //기존 저장된 할인정보 있을 때
                for (var i = 0; i < data.discountList.length; i++) {
                    if (data.custPlanInfo.dcSqnoList.includes(data.discountList[i].dcSqno)) {
                        that.cpChoice(data.discountList[i])     //할인정보 선택
                    }
                }
                that.cpEA = that.custPlanInfo.dcSqnoList.length
                that.cpSelected()   //할인정보 계산
            }
        }
        if (data.cateCntList) {
            that.cateCntList = data.cateCntList
        }
        if (data.monthAmt) {
            that.monthAmt = data.monthAmt
        }
        that.dcRt = data.dcRt;

        // 전집 할인율 변경 시 고지
        let discountedProduct = _(that.productList)
            .filter(p => {
                return p.dcYn === 'Y';
            })
            .head();
        if (discountedProduct && discountedProduct.dcRt != that.dcRt) {
            alert(`전집 할인율이 ${discountedProduct.dcRt}%에서 ${that.dcRt}%로 조정되었습니다.`);
        }
    })
    .catch(function(error) {
        alert(error.rtMsg);
    });

  },
};
</script>
<style>
    div.edu-cart dt > button em.underline{ text-decoration: underline; }
</style>